import { render, staticRenderFns } from "./exportpcdt.vue?vue&type=template&id=6f1c5844&scoped=true&"
import script from "./exportpcdt.vue?vue&type=script&lang=js&"
export * from "./exportpcdt.vue?vue&type=script&lang=js&"
import style0 from "./exportpcdt.vue?vue&type=style&index=0&id=6f1c5844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c5844",
  null
  
)

export default component.exports